<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-form
            v-model="valid"
            lazy-validation
            ref="form"
            id="new-patient-form">
    <v-layout
      justify-center
      wrap
    >

      <v-flex
        xs12
        md8
      >

        <material-card
          color="green"
          title="تعديل معلومات المستخدم"
          text="يرجى ادخال معلومات المستخدم وتحديد الصلاحيات و كلمة السر الخاصه للدخول الى النظام"
        >

            <v-container py-0>
              <v-layout wrap>

                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                          clearable
                          autocomplete="new-user"
                          v-model="username"
                          class="purple-input"
                          required
                          :rules="usernameRule"
                          label="إسم المستخدم"

                  />
                </v-flex>
                  <v-flex
                          xs12
                          md6
                  >
                      <v-text-field
                              clearable
                              v-model="password"
                              type="password"
                              autocomplete="new-password"

                              class="purple-input"
                              label="كلمة السر"

                      />
                  </v-flex>

                  <v-flex
                          xs12
                          md6
                  >
                      <v-text-field
                              clearable
                              v-model="password2"
                              type="password"
                              autocomplete="new-password"
                              class="purple-input"
                              label="تأكيد كلمة السر"

                      />
                  </v-flex>



                  <v-flex
                          xs12
                          md6
                  >
                      <v-text-field
                              v-model="fullname"
                              required
                              :rules="nameRules"
                              label="إسم المستخدم الثلاثي"

                      />
                  </v-flex>

                  <v-flex
                          xs12
                          md4>
                      <v-combobox
                              :items="provinces"
                              v-model="province"
                              item-text="text"
                              label="المحافظة"
                              return-object
                      ></v-combobox>

                  </v-flex>

               <v-flex
                   xs12
                   md4>
                   <v-combobox
                           :items="healthdeps"
                           v-model="healthdep"
                           item-text="text"
                           label="دائرة الصحة"
                           return-object
                   ></v-combobox>

                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="healthsector"
                    label="القطاع"
                    class="purple-input"
                     :ruls="nameRules"
                    required
                    />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                  v-model="healthcenter"
                    label="المركز الصحي"
                    class="purple-input"
                     :ruls="nameRules"
                    required/>
                </v-flex>

                <v-flex
                  xs12
                  md4
                >

                <v-text-field
                  v-model="jobtitle"
                    label="العنوان الوظيفي"
                    class="purple-input"
                     :ruls="nameRules"
                    required/>
                </v-flex>

                <v-flex
                  xs12
                  md4>
                  <v-combobox
                    v-model="profileid"
                    item-text="text"
                    return-object
                    :items="profiles"
                    label="صنف الصلاحيات"
                  ></v-combobox>
                </v-flex>

                  <v-flex
                          xs12
                          md4>
                      <v-combobox
                              v-model="groupid"
                              item-text="text"
                              return-object
                              :items="groups"
                              label="المجموعة"
                      ></v-combobox>
                  </v-flex>



              </v-layout>
            </v-container>

        </material-card>
      </v-flex>
          <v-flex
                  class="bluegray"
                  md12
                  xs12
                  text-xs-right
                    >



            <v-btn
                @click="validateFunc"
                :disabled="!valid"
                form="new-patient-form"
                class="mx-0 font-weight-bold"
                color="success"
            >
تعديل معلومات المستخدم
            </v-btn>






          </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import {__HTTP,FormHeader} from "@/utils/utils";
  export default {
    computed: {

    },
    data: () => ({
        valid: true,
        usernameRule: [
            v => !!v || 'هذا الحقل مطلوب',
            v => v.length > 3 || 'الحروف المدخلة قليلة',
        ],
        passwordRule: [
            v => !!v || 'هذا الحقل مطلوب',
            v => v.length > 8 || 'الحروف المدخلة قليلة',
        ],
        nameRules: [
        v => !!v || 'هذا الحقل مطلوب',
        v => v.length > 1 || 'الحروف المدخلة قليلة',
        ],
        emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
        ],
        username: '',
        fullname: '',
        password: '',
        healthsector: '',
        healthdep: null,
        province: null,
        healthcenter: '',
        jobtitle: '',
        profileid: '',
        groupid:'',
        password2: '',
        groups: [],
        healthdeps: [],

        provinces: [],
        id: 0,
        profiles:[],
    }),
    created() {
      this.provinces = this.$store.state.iraqprovs;

      this.getHealthDeps()
    },
    methods: {
      getHealthDeps() {
        __HTTP("?do=gethealthdeps",{},FormHeader,(res) => {
          res.map((i) => {
            this.healthdeps.push({
              text: i.title,
              value: i.id
            });
          });
          this.getUserInfo();
          // return x;
        });
      },
      validateFunc() {
        if (this.$refs.form.validate()) {
          this.submitForm()
        }
      },
        getProfiles() {
            __HTTP("?do=getonlyprofiles",{},FormHeader,(res) => {
                res.map((i) => {
                    this.profiles.push({
                        text: i.title,
                        value: i.id
                    });
                });

                let index = this.profiles.findIndex(obj => obj.value == this.profileid);
                this.profileid = {text: this.profiles[index].text, value: this.profiles[index].value}
            });
        },
      getGroups() {
      __HTTP("?do=getgroups",{},FormHeader,(res) => {

              res.map((i) => {
                this.groups.push({
                  text: i.title,
                  value: i.id
                });
              });
                let index = this.groups.findIndex(obj => obj.value == this.groupid);
              this.groupid = {text: this.groups[index].text, value: this.groups[index].value}
          });
    },
      getUserInfo() {
        __HTTP("?do=getuserinfo&id="+this.$route.query.id,{},FormHeader,(res) => {
          console.log(res);
          this.username = res.username;
          this.fullname = res.fullname;
          this.healthsector = res.healthsector
          this.healthcenter = res.healthcenter;
          let hindex = this.healthdeps.findIndex(i => i.value == parseInt(res.healthdep))
          this.healthdep = this.healthdeps[hindex];
          this.jobtitle = res.jobtitle;
          this.groupid = res.groupid;
            this.id = res.id;
            this.profileid = res.profileid;
            let index = this.provinces.findIndex(i => i.value == parseInt(res.province))
          this.province =  this.provinces[index];
          console.log(this.province);
          console.log(this.groupid);
          this.getGroups();
          this.getProfiles();

        })
      },
      submitForm() {
        __HTTP("?do=newusers",JSON.stringify({
          username: this.username,
          password: this.password,
          fullname: this.fullname,
          healthdep: this.healthdep.value,
          healthsector: this.healthsector,
          healthcenter: this.healthcenter,
          province: this.province.value,
          jobtitle: this.jobtitle,
          profileid: this.profileid.value,
          groupid: this.groupid.value,
          id: this.id,
          isedit: true
        }),FormHeader,(res) => {
          console.log(res);
          if (res.auth == true) {
            this.$router.push({path: '/list-users'})
          }
        });

      }
    }
  }
</script>

